import React, { useState, useEffect } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { useForm } from '../../hooks/useForm'
import backArrowIcon from '../../assets/img/back-arrow.png';
import "../../assets/css/common.css";
import { useAuth } from '../../routers/AuthProvider';
import { API_URL } from '../../utils/constant';
import axios from 'axios';
import { Toast } from '../../components/ToastComponent';



export default function CreateRedeemedGift() {
    const backPath = `/loyalty/redeemed-gift/list`;
    const { handleInputChange, formData, submitForm, setError, error } = useForm();
     useEffect(()=>{
                      if(error){
                         Toast.fire({
                  title: error ,
                  icon: "error",
                });
                      }
                  },[error])
    const navigate = useNavigate();
    const { user, setLoading } = useAuth();
    const onSubmit = (e) => {
        e.preventDefault();
        setLoading(true)
        const data = {
            ...formData,
            status: 'ACTIVE',
        }
        submitForm('POST', '/issuePresent', data, () => {
        //     navigate(backPath)
        // });
         navigate(backPath)
        }, "Successfully Created");
    }


     const [errorMessage, setErrorMessage] = useState("");
        const [qty, setQty] = useState("");

    const handleQtyChange = (e) => {
        const rawValue = e.target.value || "";
        const numericValue = rawValue.replace(/[^0-9]/g, "");
        setQty(numericValue);

        const numeric = parseInt(numericValue, 10);

        if (!numericValue) {
            setErrorMessage("Please enter a number.");
        } else if (isNaN(numeric) || numeric < 1) {
            setErrorMessage("Number must be 1 or greater.");
        } else {
            setErrorMessage("");
        }

        handleInputChange({ target: { name: "qty", value: numericValue } });
    };

    const handleQtyBeforeInput = (e) => {
        if (e.data && /[^0-9]/.test(e.data)) {
            e.preventDefault();
        }
    };

    const handleQtyPaste = (e) => {
        const pastedText = e.clipboardData?.getData("text") ?? "";
        if (/[^0-9]/.test(pastedText)) {
            e.preventDefault();
        }
    };

    const [presents, setPresents] = useState();
    const [presentRules, setPresentRules] = useState();
    const [retailCustomers, setRetailCustomers] = useState();
    const localData = JSON.parse(localStorage.getItem('user')) ?? {};
    useEffect(() => {
        axios.get(API_URL + '/present?status=ACTIVE', {
            headers: {
                'Authorization': `Bearer ${localData?.token}`
            },
            withCredentials: true
        })
            .then(response => {
                setPresents(response.data.data)
            })
    }, []);

    useEffect(() => {
        axios.get(API_URL + '/presentRule?status=ACTIVE', {
            headers: {
                'Authorization': `Bearer ${localData?.token}`
            },
            withCredentials: true
        })
            .then(response => {
                setPresentRules(response.data.data)
            })
    }, []);

    useEffect(() => {
        axios.get(API_URL + '/retailCustomer?status=ACTIVE', {
            headers: {
                'Authorization': `Bearer ${localData?.token}`
            },
            withCredentials: true
        })
            .then(response => {
                setRetailCustomers(response.data.data)
            })
    }, []);

    return (
        <div className='sub-page-layout-1'>
            <Link className='back-to-page' to={backPath}>
                <img src={backArrowIcon} />
                Back
            </Link>
            <div className='container' style={{ height: 'auto' }}>
                <h1 className='sub-page-title'>Create New Redeemed Gift</h1>
                <div className='form-container'>
                    <form onSubmit={onSubmit} className='form flex flex-col justify-between w-full'>
                        <h2 className='sub-title mb-8'>Redeemed Gift Information</h2>
                        <div className='grid grid-cols-2 gap-9'>
                            <div className='grow'>
                                <label className='x-label input-required'>Gift Name</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        name='present_id'
                                        required
                                        onChange={handleInputChange}
                                        defaultValue=''
                                        className='x-input dropdown'
                                    >
                                        <option value='' disabled>Select</option>
                                        {presents && presents.map((item, index) => (
                                            <option key={index} value={item.present_id}>{item.present_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='grow'></div>
                            <div className='grow'>
                                <label className='x-label input-required'>Gift Rule Name</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        name='present_rule_id'
                                        required
                                        onChange={handleInputChange}
                                        defaultValue=''
                                        className='x-input dropdown'
                                    >
                                        <option value='' disabled>Select</option>
                                        {presentRules && presentRules.map((item, index) => (
                                            <option key={index} value={item.present_rule_id}>{item.present_rule_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Quantity</label>
                                <input type='text'
                                    required
                                    name='qty'
                                    value={qty}
                                    autoComplete='false'
                                    pattern="[0-9]{1,}"
                                    inputMode='numeric'
                                    onBeforeInput={handleQtyBeforeInput}
                                    onPaste={handleQtyPaste}
                                    onChange={handleQtyChange}
                                    onKeyDown={e => {
                                        if (e.key === "Enter") {
                                            e.preventDefault();
                                        }
                                    }}
                                    className='x-input' />
                                    {errorMessage && (
                                    <div className="text-red-500 text-sm mt-1">{errorMessage}</div>
                                )}
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Retail Customer Name</label>
                                <div className='dd-container'>
                                    <select
                                        type='text'
                                        name='retail_customer_id'
                                        required
                                        onChange={handleInputChange}
                                        defaultValue=''
                                        className='x-input dropdown'
                                    >
                                        <option value='' disabled>Select</option>
                                        {retailCustomers && retailCustomers.map((item, index) => (
                                            <option key={index} value={item.customer_id}>{item.customer_name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className='grow'>
                                <label className='x-label input-required'>Date</label>
                                <input type='date'
                                    required
                                    name='date'
                                    autoComplete='false'
                                    onChange={handleInputChange}
                                    className='x-input' />
                            </div>
                        </div>
                        <div className='form-btn-group'>
                           
                            <div className='flex justify-end gap-5 mt-5'>
                                <Link to={backPath} className='white-btn'>Cancel</Link>
                                <button className='gold-btn'>Create</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}
